import 'bootstrap';
import './frontpage-akhbar.js';
import './slider.js';

((Drupal, _once) => {
  Drupal.behaviors.zi1448 = {
    attach: (_context, _settings) => {
      // Custom behaviors can be added here.
    },
  };
})(Drupal, once);
